import { utils } from '../utils/utils';
import { HttpClient } from './serviceBase';

class OrderHistoryService {
    Search = async (filters) => {
        const queryString = utils.GetQueryStringsFromObject( filters )
        return await HttpClient.Get(`/api/orderHistory/search?${queryString}`);
    }
}

export default new OrderHistoryService();